import { createApiSlice } from "@common";
import {
  CRUD_PROSPECT_CONTACT_ENGAGEMENT,
  GET_PROSPECT_CONTACT_ENGAGEMENT_BY_PROSPECT_CONTACT_ID
} from "@routes";

// 1 to 1
const apiConfig = [
  {
    name: "addProspectContactEngagement",
    method: "post",
    url: CRUD_PROSPECT_CONTACT_ENGAGEMENT,
    stateKey: "message",
  },
  {
    name: "getProspectContactEngagementByProspectContactId",
    method: "get",
    url: GET_PROSPECT_CONTACT_ENGAGEMENT_BY_PROSPECT_CONTACT_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "prospectContactEngagement",
  apiConfig,
  customReducers,
);
const prospectContactEngagementSlice = slice;

export default prospectContactEngagementSlice.reducer;

export const {
  addProspectContactEngagement,
  getProspectContactEngagementByProspectContactId,
} = thunks;

export const { rowSelect } = actions;
